module.exports = __webpack_public_path__ + "assets/img/creationMng_(1).1f3f8d61.png";